import React, {useState} from "react";
import {Button, UncontrolledTooltip} from "reactstrap";
import _uniqueId from "lodash/uniqueId";
import {IconSource} from "../../../shared/enums/iconSource";
import Icon from "../common/icon/icon";
import "./navigationButton.sass";

export interface INavigationButtonProps {
  icon: IconSource;
  tooltip?: string | null;
  disabled?: boolean;
  onClick?: () => void;
}

const NavigationButton: React.FC<INavigationButtonProps> = ({
  icon,
  tooltip = null,
  disabled,
  onClick
}) => {
  const [id] = useState(_uniqueId("navbutton-"));
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

  return (
    <>
      <Button
        className="navigation-button"
        onClick={onClick}
        onMouseEnter={(e) => {
          setTooltipIsOpen(true);
        }}
        onMouseLeave={(e) => {
          setTooltipIsOpen(false);
        }}
        disabled={disabled}
        id={id}
      >
        <Icon source={icon} />
      </Button>
      {tooltip && (
        <UncontrolledTooltip target={id} isOpen={tooltipIsOpen}>
          {tooltip}
        </UncontrolledTooltip>
      )}
    </>
  );
};

export default NavigationButton;
